<template>
    <el-dialog class="el-dialogs" :title="title" :append-to-body="true" width="800px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row>
            <el-col :span="10" class="seleTb">
                <div class="minTitle">选择元数据</div>
                <el-checkbox :indeterminate="indeterminate" v-model="selectAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-tree
                        v-loading="loading"
                        style="height:380px;overflow-y: auto"
                        ref="tree"
                        :data="allDataList"
                        show-checkbox
                        node-key="basicCode"
                        :check-strictly="true"
                        default-expand-all
                        @check="handleCheckedCitiesChange"
                        :props="defaultProps">
                </el-tree>
            </el-col>
            <el-col :span="4" class="text_center seleMiddle">
                <div>
                    <el-button size="mini" type="primary" @click="moveData('left')">添加元数据 <i
                            class="el-icon-arrow-right"></i></el-button>
                </div>
                <div style="margin-top: 30px">
                    <el-button size="mini" icon="el-icon-arrow-left" @click="moveData('right')">取消元数据</el-button>
                </div>
            </el-col>
            <el-col :span="10" class="seleTb">
                <div class="minTitle">已选择元数据</div>
                <el-table
                        :data="rightDataList"
                        size="small" height="400px"
                        class="table" border
                        ref="rightTable"
                        :row-key="'basicCode'"
                        :tree-props="{children: 'aaaaaaa',}"
                        @selection-change="rightSelection"
                >
                    <el-table-column :reserve-selection="true" type="selection" width="50"/>
                    <el-table-column prop="basicRename" label="已选择元数据名称"
                                     show-overflow-tooltip></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div slot="footer" class="text_right">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="sureData()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "selectMetadata",
    data() {
        return {
            title: '选择元数据',
            visible: false,
            loading:false,
            allDataList: [],
            defaultProps: {
                children: 'children',
                label: 'basicRename'
            },
            rightDataList: [],
            rightDataListSelect: [],
            selectData: [],

            selectAll:false,
            indeterminate:true,
            allTreeList:[],
        }
    },

    methods: {
        init(basicDataId, selectData) {
            this.visible = true
            this.rightDataList = []
            this.selectData = selectData
            this.getAllData(basicDataId)
        },

        getAllData(basicDataId) {
            this.loading = true
            this.$axios(this.api.metadata.selectTreeMetadataBasicDataById, {
                basicDataId: basicDataId,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.allDataList = data.data.children
                    this.allTreeList = []
                    this.setDatadisabled(this.allDataList)
                    if (this.selectData.length == 0) {
                        this.$axios(this.api.metadata.metadatabasicSelectBasicSys, {}, 'get').then(data => {
                            if (data && data.status) {
                                data.data.forEach(item => {
                                    this.$refs.tree.setChecked(item.basicCode, true)
                                })
                            }
                        })
                    } else {
                        this.rightDataList = this.selectData
                        this.selectData.forEach(item => {
                            this.$refs.tree.setChecked(item.basicCode, true)
                        })
                    }
                }
                this.loading = false
            })
        },

        setDatadisabled(list) {
            if (!list && list.length == 0) return
            list.forEach(item => {
                item.disabled = false
                this.allTreeList.push(item)
                if (item.children) {
                    this.setDatadisabled(item.children)
                }
            })
        },

        //全选
        handleCheckAllChange(val){
            if (val){
                this.allTreeList.forEach(item=>{
                    this.$refs.tree.setChecked(item.basicCode, true)
                })
            }else {
                this.allTreeList.forEach(item=>{
                    this.$refs.tree.setChecked(item.basicCode, false)
                })
            }
            this.indeterminate = false;
        },

        handleCheckedCitiesChange(){
            let checkedCount = this.$refs.tree.getCheckedNodes()
            this.selectAll = checkedCount.length === this.allTreeList.length;
            this.indeterminate = checkedCount.length > 0 && checkedCount.length < this.allTreeList.length;
        },

        //移动数据 left移动左边的数据 right移动右边的数据
        moveData(name) {
            if (name == 'left') {
                this.rightDataList = this.$refs.tree.getCheckedNodes()
            } else {
                if (this.rightDataListSelect.length == 0) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                this.rightDataListSelect.forEach(item1 => {
                    this.$refs.tree.setChecked(item1.basicCode, false)
                    this.rightDataList = this.rightDataList.filter(item2 => {
                        return item2.basicCode != item1.basicCode
                    })
                })
                this.$refs.rightTable.clearSelection()
            }
            this.handleCheckedCitiesChange()
        },

        //右边表格勾选数据
        rightSelection(val) {
            this.rightDataListSelect = val
        },

        sureData() {
            if (!this.rightDataList.length) {
                this.$message.error('请选择元数据字段')
                return
            }
            this.visible = false
            this.$emit('selectData', this.rightDataList)
        },
    },
}
</script>

<style scoped>
.seleTb {
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DCDCDC;
}

.minTitle {
    font-weight: 600;
}

.seleMiddle {
    margin-top: 26%;
}
</style>